/**
 * Спиннер (§2.3 «кнопка в загрузке», §11.1 «публикация пакета»).
 *
 * Нужен в двух местах: внутри кнопки подтверждения (14 px) и в блоках, которые
 * догружаются. Больше нигде: загрузка среза — статичный скелетон (§11.1).
 * По умолчанию декоративный: текст «Подтверждаем…» рядом говорит больше.
 */
import './Spinner.css'

export interface SpinnerProps {
  /** 14 — внутри кнопки (по умолчанию), 16 и 20 — в блоках. */
  size?: 14 | 16 | 20
  /** Доступное имя. Если задано — спиннер становится `role="status"`. */
  label?: string
  className?: string
}

export function Spinner({ size = 14, label, className }: SpinnerProps) {
  const classes = ['spinner']
  if (size !== 14) classes.push(`spinner--${size}`)
  if (className) classes.push(className)

  return (
    <svg
      className={classes.join(' ')}
      viewBox="0 0 20 20"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      focusable="false"
      role={label ? 'status' : undefined}
      aria-hidden={label ? undefined : true}
    >
      {label ? <title>{label}</title> : null}
      <circle className="spinner__track" cx="10" cy="10" r="7.5" />
      <path d="M17.5 10A7.5 7.5 0 0 0 10 2.5" />
    </svg>
  )
}
